// extracted by mini-css-extract-plugin
module.exports = {"switch":"SlidingCheckbox_switch__28PfE","slider":"SlidingCheckbox_slider__gyjYo"};